import { Container, Fieldset } from '@chakra-ui/react'
import type { FC } from 'react'
import { FiArrowLeft } from 'react-icons/fi'
import { useParams } from 'react-router-dom'

import useGetObject from '@app/hooks/useGetObject'
import LayoutRow from '@app/next/changelog/components/layoutRow'
import NavigationButton from '@app/pages/changelogs/components/navigationButton'
import EntityForm from '@app/pages/shared/entities/components/entityForm'
import HeadMetaData from '@app/shared/headMetaData'
import withAwait from '@app/shared/withAwait'
import { pathWithSearchParams } from '@app/utils/routeHelpers'

const Edit: FC = () => {
  const { entityId } = useParams()
  const entity = useGetObject(entityId, 'entity')

  if (!entity) {
    return null
  }

  const entityPath = pathWithSearchParams(`events/${entity.id}`)
  const backButtonPath = pathWithSearchParams('..')

  return (
    <Container>
      <HeadMetaData
        title={entity.name}
        description={entity.summaryShort}
        url={entityPath}
        imageUrl={entity.thumbnail?.url}
      />

      <LayoutRow pb={8}>
        <Fieldset.Root>
          <Fieldset.Content>
            <EntityForm entity={entity} />
          </Fieldset.Content>
        </Fieldset.Root>
        <NavigationButton url={backButtonPath} label="Back to overview" leftIcon={<FiArrowLeft />} mt={6} />
      </LayoutRow>
    </Container>
  )
}

export default withAwait(Edit, 'entity')
